<ng-container *ngIf="view$ | async as view">
    <div class="missed-calls" role="region" aria-label="Missed calls" *ngIf="view.visible.length || view.doNotDisturb">
        <div class="missed-call" role="status" aria-live="polite" *ngFor="let call of view.visible; trackBy: trackById">
            <i class="fa-solid missed-call-icon" [class.fa-video-slash]="isVideo(call)" [class.fa-phone-xmark]="!isVideo(call)"></i>
            <span class="missed-call-message">{{ messageOf(call) }}</span>
            <button type="button" class="missed-call-action" (click)="onCallBack(call)"
                    [attr.aria-label]="'Call back ' + (call.callerName || call.callerEmail)">
                <i class="fa-solid fa-phone"></i>
                <span>Call back</span>
            </button>
            <button type="button" class="missed-call-close" (click)="onDismiss(call)" aria-label="Dismiss">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="missed-call-more" *ngIf="view.hidden">+{{ view.hidden }} more</div>
        <app-dnd-toggle variant="pill"></app-dnd-toggle>
    </div>
</ng-container>
